import { Transaction } from './Transaction';

export class ExpandedTransaction {
  tran: Transaction;
  expanded?: boolean;
  c2cDetails?: any;
  tranDetails?: any;
  acctType?: any;
}
